import pat from "./pat.png";
import bruce from "./bruce.png";
import hilary from "./hilary.png";
import jeff from "./jeff.png";
import meryl from "./meryl.png";
import will from "./will.png";
export { default as question } from "./question.png";

const faces = [pat, bruce, hilary, jeff, meryl, will];

export default faces;
